import API from "../helpers/API"

const HighlightsController = {
  fetchAll() {
    return API.request("/v1/highlight/all", [], "GET")
  },
}

export default HighlightsController
